import readableFilterUsagesSummary from "search-filter/readableFilterUsagesSummary";
import StringUtils from "util/StringUtils";
const confirmActionUsagesAlert = ({
  action,
  usagesSummary,
  additionalExplanation = ""
}) => (
  // eslint-disable-next-line no-alert
  window.confirm(
    `This search filter is being referenced by ${readableFilterUsagesSummary(usagesSummary)}. ${action} the search filter query will affect ${StringUtils.pluralize(usagesSummary.length, "its", "their")} search result.${additionalExplanation}`
  )
);
export default confirmActionUsagesAlert;
